package horcrux.browserapp.externals.firebase

import horcrux.browserapp.externals.firebase.wrappers.Analytics
import horcrux.browserapp.externals.firebase.wrappers.FirebaseApp
import horcrux.browserapp.externals.firebase.wrappers.initializeApp
import kotlin.js.json

data class FirebaseOptions(
    val apiKey: String,
    val projectId: String,
    val storageBucket: String,
    val appId: String,
    val measurementId: String? = null,
//    val measurementId: String? = "G-ZVV3D3X2CJ",
) {
    constructor(firebaseOptions: dev.gitlive.firebase.FirebaseOptions) : this(
        apiKey = firebaseOptions.apiKey,
        projectId = firebaseOptions.projectId ?: error("projectId must be specified"),
        storageBucket = firebaseOptions.storageBucket ?: error("storageBucket must be specified"),
        appId = firebaseOptions.applicationId
    )
}

class FirebaseApp internal constructor(private val wrapped: FirebaseApp) {
    companion object {
        fun initialize(options: FirebaseOptions, name: String? = null) = FirebaseApp(
            initializeApp(
                json(
                    "apiKey" to options.apiKey,
                    "projectId" to options.projectId,
                    "storageBucket" to options.storageBucket,
                    "appId" to options.appId,
                    "measurementId" to options.measurementId,
                ),
                name
            )
        )
    }

    val name get() = wrapped.name
    val options
        get() = FirebaseOptions(
            apiKey = wrapped.options.apiKey,
            projectId = wrapped.options.projectId,
            storageBucket = wrapped.options.storageBucket,
            appId = wrapped.options.appId,
            measurementId = wrapped.options.measurementId,
        )

    fun getAnalytics() = Analytics(horcrux.browserapp.externals.firebase.wrappers.getAnalytics(wrapped))
    fun initializeAnalytics(settings: AnalyticsSettings) =
        Analytics(horcrux.browserapp.externals.firebase.wrappers.initializeAnalytics(
            wrapped,
            object : horcrux.browserapp.externals.firebase.wrappers.AnalyticsSettings {
                override val config = settings.gtagParams.toJson()
            }
        ))

}
